/**
 * Used to evaluate if our code is running server side or not
 * @returns {boolean}
 */
export default function isServerSide() {
    return typeof window === 'undefined';
}
